(function () {
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  const REFRESH_DELAY = 300;

  function isCartDrawerOpen() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    if (drawer.hasAttribute('open')) return true;
    if (drawer.classList.contains('is-open') || drawer.classList.contains('active')) return true;
    const style = window.getComputedStyle(drawer);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  async function refreshDrawerAndOpen() {
    try {
      if (isCartDrawerOpen()) {
        console.log('Drawer already open — skipping refresh');
        return;
      }

      const res = await fetch(`/?sections=${SECTIONS.join(',')}`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Failed to fetch sections');
      const data = await res.json();

      const drawer = document.querySelector('cart-drawer');
      const iconBubble = document.querySelector('[data-cart-icon-bubble]') || document.querySelector('.cart-count-bubble');

      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents({
          id: Date.now(),
          sections: {
            'cart-drawer': data['cart-drawer'],
            'cart-icon-bubble': data['cart-icon-bubble'],
          },
        });
      } else if (drawer) {
        drawer.innerHTML = data['cart-drawer'];
      }

      if (iconBubble && data['cart-icon-bubble']) {
        iconBubble.innerHTML = data['cart-icon-bubble'];
      }

      const drawerEl = document.querySelector('cart-drawer');
      if (drawerEl && typeof drawerEl.open === 'function') drawerEl.open();
      else document.body.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
    } catch (err) {
      console.warn('[Cart Drawer Refresh Error]', err);
      const fallback = document.querySelector('cart-drawer');
      if (fallback && typeof fallback.open === 'function') fallback.open();
    }
  }

  let bubbleObserver = null;
  let bodyObserver = null;
  let debounceTimer = null;
  let currentBubble = null;

  function observeBubble(bubble) {
    if (!bubble || currentBubble === bubble) return;
    
    if (bubbleObserver) {
      bubbleObserver.disconnect();
      bubbleObserver = null;
    }

    console.log('Watching cart-count-bubble changes', bubble);
    currentBubble = bubble;

    bubbleObserver = new MutationObserver((mutations) => {
      let shouldRefresh = false;
      
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          shouldRefresh = true;
          break;
        }
        
        if (mutation.type === 'characterData' || mutation.type === 'childList') {
          shouldRefresh = true;
          break;
        }
      }

      if (shouldRefresh) {
        console.log('Cart bubble updated — refreshing drawer');
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(refreshDrawerAndOpen, REFRESH_DELAY);
      }
    });

    bubbleObserver.observe(bubble, { 
      childList: true, 
      characterData: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-count', 'style']
    });

    if (bubble.parentNode) {
      bubbleObserver.observe(bubble.parentNode, {
        childList: true,
        subtree: false
      });
    }
  }

  function findAndObserveBubble() {
    const bubble = document.querySelector('.cart-count-bubble') || 
                   document.querySelector('[data-cart-icon-bubble]') ||
                   document.querySelector('[class*="cart-count"]') ||
                   document.querySelector('[class*="cart-bubble"]');
    
    if (bubble) {
      observeBubble(bubble);
    } else {
      console.log('No cart bubble found — waiting for dynamic render');
    }
  }

  function attachWatcher() {
    findAndObserveBubble();

    if (!bodyObserver) {
      bodyObserver = new MutationObserver((mutations) => {
        let bubbleAdded = false;
        
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) {
              if (node.matches && (
                node.matches('.cart-count-bubble') ||
                node.matches('[data-cart-icon-bubble]') ||
                node.matches('[class*="cart-count"]') ||
                node.matches('[class*="cart-bubble"]')
              )) {
                bubbleAdded = true;
                break;
              }
              
              const bubbleInside = node.querySelector && (
                node.querySelector('.cart-count-bubble') ||
                node.querySelector('[data-cart-icon-bubble]') ||
                node.querySelector('[class*="cart-count"]') ||
                node.querySelector('[class*="cart-bubble"]')
              );
              
              if (bubbleInside) {
                bubbleAdded = true;
                break;
              }
            }
          }
          if (bubbleAdded) break;
        }

        if (bubbleAdded) {
          console.log('New cart bubble detected in DOM');
          setTimeout(findAndObserveBubble, 100);
        }
      });

      bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  document.addEventListener('shopify:section:load', findAndObserveBubble);
  document.addEventListener('shopify:section:unload', findAndObserveBubble);
  document.addEventListener('cart:item-added', findAndObserveBubble);
  document.addEventListener('cart:item-removed', findAndObserveBubble);
  document.addEventListener('cart:item-updated', findAndObserveBubble);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachWatcher);
  } else {
    attachWatcher();
  }

  setInterval(findAndObserveBubble, 1000);
})();

/*(function() {
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  const REFRESH_DELAY = 100; // Reduced from 300ms to 100ms

  function isDrawerOpen() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    if (drawer.hasAttribute('open')) return true;
    if (drawer.classList.contains('is-open') || drawer.classList.contains('active')) return true;
    const style = window.getComputedStyle(drawer);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  async function refreshDrawer() {
    if (isDrawerOpen()) return;
    
    try {
      const res = await fetch(`/?sections=${SECTIONS.join(',')}`, { credentials: 'same-origin' });
      const data = await res.json();
      
      const drawer = document.querySelector('cart-drawer');
      const bubble = document.querySelector('[data-cart-icon-bubble]') || document.querySelector('.cart-count-bubble');

      if (drawer) {
        if (typeof drawer.renderContents === 'function') {
          drawer.renderContents({
            id: Date.now(),
            sections: {
              'cart-drawer': data['cart-drawer'],
              'cart-icon-bubble': data['cart-icon-bubble']
            }
          });
        } else {
          drawer.innerHTML = data['cart-drawer'];
        }
      }

      if (bubble && data['cart-icon-bubble']) {
        bubble.innerHTML = data['cart-icon-bubble'];
      }

      const drawerEl = document.querySelector('cart-drawer');
      if (drawerEl && typeof drawerEl.open === 'function') {
        drawerEl.open();
      } else {
        document.body.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
      }
    } catch (err) {
      console.warn('Cart refresh error:', err);
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    }
  }

  let bubbleObserver = null;
  let bodyObserver = null;
  let debounceTimer = null;
  let currentBubble = null;

  function watchBubble(bubble) {
    if (!bubble || currentBubble === bubble) return;
    
    if (bubbleObserver) bubbleObserver.disconnect();
    
    currentBubble = bubble;
    bubbleObserver = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(refreshDrawer, REFRESH_DELAY);
    });

    bubbleObserver.observe(bubble, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-count', 'style']
    });

    if (bubble.parentNode) {
      bubbleObserver.observe(bubble.parentNode, {
        childList: true,
        subtree: false
      });
    }
  }

  function findBubble() {
    const bubble = document.querySelector('.cart-count-bubble') || 
                   document.querySelector('[data-cart-icon-bubble]') ||
                   document.querySelector('[class*="cart-count"]');
    if (bubble) watchBubble(bubble);
  }

  function initWatcher() {
    findBubble();

    if (!bodyObserver) {
      bodyObserver = new MutationObserver(() => {
        setTimeout(findBubble, 50);
      });

      bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  // Event listeners
  document.addEventListener('shopify:section:load', findBubble);
  document.addEventListener('shopify:section:unload', findBubble);
  document.addEventListener('cart:item-added', findBubble);
  document.addEventListener('cart:item-removed', findBubble);
  document.addEventListener('cart:item-updated', findBubble);

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWatcher);
  } else {
    initWatcher();
  }

  setInterval(findBubble, 500);
})();*/